"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkIfContactExistsByName = checkIfContactExistsByName;
exports.checkIfContactExistsByWebID = checkIfContactExistsByWebID;
exports.getAddressBooksData = getAddressBooksData;
exports.getContactData = getContactData;
var _rdflib = require("rdflib");
var _solidUi = require("solid-ui");
var _solidLogic = require("solid-logic");
var _texts = require("../../texts");
var _contactsErrors = require("./contactsErrors");
async function getAddressData(context, contactsModule, addressBookUri) {
  let result = null;
  try {
    result = await contactsModule.readAddressBook(addressBookUri);
  } catch (error) {
    (0, _contactsErrors.addErrorToErrorDisplay)(context, `${_texts.errorReadingAddressBook}\n${error}`);
  }
  return result;
}
async function getWebID(context, contact) {
  let webID = null;
  let node = null;
  let webIDNode = null;
  try {
    await context.session.store.fetcher.load(contact.uri.substring(0, contact.uri.length - 5));
    node = new _rdflib.NamedNode(contact.uri);
    webIDNode = context.session.store.any(node, _solidUi.ns.vcard('url'), undefined, node.doc());
    if (webIDNode) {
      webID = context.session.store.anyValue(webIDNode, _solidUi.ns.vcard('value'), undefined, node.doc());
      return {
        webID,
        uri: contact.uri
      };
    }
    return null;
  } catch (error) {
    (0, _contactsErrors.addErrorToErrorDisplay)(context, `${_texts.errorLoadingContact}${contact.uri}\n${error}`);
  }
}
async function processContactWebIDs(context, addressBooksData, allContacts) {
  const contactPromises = allContacts.map(getWebID.bind(null, context));
  const results = await Promise.all(contactPromises);
  results.map(contact => {
    if (contact?.webID) addressBooksData.contactWebIDs.set(contact.webID.trim(), contact.uri);
  });
  return addressBooksData;
}
async function getAddressBooks(context, contactsModule) {
  const allContacts = [];
  const me = _solidLogic.authn.currentUser();
  let addressBooksData = {
    public: new Map(),
    private: new Map(),
    contactWebIDs: new Map(),
    contactNames: new Map()
  };
  try {
    await context.session.store.fetcher.load(me);
    const addressBookUris = await contactsModule.listAddressBooks(me.value);
    const publicAddressBookPromises = addressBookUris.publicUris.map(addressBook => getAddressData(context, contactsModule, addressBook));
    const publicAddressBooksData = await Promise.all(publicAddressBookPromises);
    publicAddressBooksData.map(addressBook => {
      if (!addressBook) return;
      addressBooksData.public.set(addressBook.uri, {
        name: addressBook.title,
        groups: addressBook.groups,
        contacts: addressBook.contacts
      });
      addressBook.contacts.map(contact => {
        addressBooksData.contactNames.set(contact.name, contact.uri);
        allContacts.push(contact);
      });
    });
    const privateAddressBookPromises = addressBookUris.privateUris.map(addressBook => getAddressData(context, contactsModule, addressBook));
    const privateAddressBooksData = await Promise.all(privateAddressBookPromises);
    privateAddressBooksData.map(addressBook => {
      if (!addressBook) return;
      addressBooksData.private.set(addressBook.uri, {
        name: addressBook.title,
        groups: addressBook.groups,
        contacts: addressBook.contacts
      });
      addressBook.contacts.map(contact => {
        addressBooksData.contactNames.set(contact.name, contact.uri);
        allContacts.push(contact);
      });
    });
    addressBooksData = await processContactWebIDs(context, addressBooksData, allContacts);
  } catch (error) {
    (0, _contactsErrors.addErrorToErrorDisplay)(context, error);
  }
  return addressBooksData;
}
async function getAddressBooksData(context, contactModule) {
  const me = _solidLogic.authn.currentUser();
  if (!me) return null;
  let addressBooksData = null;
  try {
    addressBooksData = await getAddressBooks(context, contactModule);
  } catch (error) {
    (0, _contactsErrors.addErrorToErrorDisplay)(context, `${_texts.errorGettingAddressBooks}\n${error}`);
  }
  return addressBooksData;
}
async function getContactData(store, subject) {
  const emails = [];
  const phoneNumbers = [];
  let type = null;
  let email = null;
  let phoneNumber = null;
  const name = _solidUi.utils.label(subject);
  const nickname = store.anyValue(subject, _solidUi.ns.foaf('nick'), null, subject.doc()) || undefined;
  const preferredSubjectPronoun = store.anyValue(subject, _solidUi.ns.solid('preferredSubjectPronoun'), null, subject.doc()) || undefined;
  const preferredObjectPronoun = store.anyValue(subject, _solidUi.ns.solid('preferredObjectPronoun'), null, subject.doc()) || undefined;
  const preferredRelativePronoun = store.anyValue(subject, _solidUi.ns.solid('preferredRelativePronoun'), null, subject.doc()) || undefined;
  const emailNodes = store.each(subject, _solidUi.ns.vcard('hasEmail'), null, subject.doc()) || null;
  const phoneNodes = store.each(subject, _solidUi.ns.vcard('hasTelephone'), null, subject.doc()) || null;
  emailNodes.map(node => {
    email = store.any(node, _solidUi.ns.vcard('value'), null, subject.doc());
    type = store.any(node, _solidUi.ns.rdf('type'), null, subject.doc());
    emails.push({
      type,
      email
    });
  });
  phoneNodes.map(node => {
    phoneNumber = store.any(node, _solidUi.ns.vcard('value'), null, subject.doc());
    type = store.any(node, _solidUi.ns.rdf('type'), null, subject.doc());
    phoneNumbers.push({
      type,
      phoneNumber
    });
  });
  const webID = subject.value;
  return {
    name,
    nickname,
    preferredSubjectPronoun,
    preferredObjectPronoun,
    preferredRelativePronoun,
    emails,
    phoneNumbers,
    webID
  };
}
function checkIfContactExistsByWebID(addressBooksData, subjectUri) {
  if (!subjectUri?.trim()) return false;
  return addressBooksData.contactWebIDs.has(subjectUri.trim());
}
function checkIfContactExistsByName(addressBooksData, name) {
  let normalizedContactName = null;
  let contactUri = null;
  const normalizedSubjectName = name.replace(/\s/g, '').toLowerCase().trim();
  addressBooksData.contactNames.forEach((uri, contactName) => {
    normalizedContactName = contactName.replace(/\s/g, '').toLowerCase().trim();
    if (normalizedSubjectName === normalizedContactName) return contactUri = uri;
  });
  return contactUri;
}